
















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { EnvironmentModule } from '@/_store/modules'
import { Meta } from '@sophosoft/vue-meta-decorator'
import { mapGetters } from 'vuex'
import { IUser, IClub } from '@/_store/models'
import { KeenFilter } from '@/interfaces'

@Component({
  computed: {
    ...mapGetters(['StateUser']),
  },
  data() {
    return {
      club: {
        group: {
          name: '',
        },
      },
    }
  },
})
export default class MemberClubView extends Vue {
  @Meta
  getMetaInfo() {
    return {
      title: `MIXONIUM | ${this.club.group.name}`,
      meta: [
        // opengraph
        { property: 'og:title', content: this.club.group.name },
        { property: 'og:type', content: 'article' },
        {
          property: 'og:url',
          content: `${EnvironmentModule.siteUrl}/public/post/${this.clubId}`,
        },
        { property: 'og:image', content: this.club.thumbnail },
        { property: 'og:description', content: this.club.group.name },
        // twitter
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:site', content: '@MIXONIUM_GHI' },
        { property: 'twitter:title', content: this.club.group.name },
        {
          property: 'twitter:description',
          content: this.club.group.name,
        },
        { property: 'twitter:image', content: this.club.thumbnail },
      ],
    }
  }

  StateUser!: IUser
  club!: IClub
  loading = true
  clubId = this.$route.params.id
  locked = false
  clubViews = 0
  clubPostViews = 0

  async trackView() {
    await this.$keenApi.trackPostOrClubEvent(
      'Club Views',
      this.$route.path,
      this.clubId,
      this.club.group.name
    )
  }

  unlockPost() {
    this.locked = false
  }

  setLock() {
    this.locked = this.club ? this.club.group.password_protected : false
  }

  async getClubViews() {
    const filter: KeenFilter[] = [
      {
        property_name: 'id',
        operator: 'eq',
        property_value: this.clubId,
      },
    ]
    const resp = await this.$keenApi.analysis(
      'count',
      'Club Views',
      'this_10_years',
      null,
      'id',
      filter
    )
    this.clubViews = resp ? resp : 0
  }

  async getClubPostViews(posts: any[]) {
    const postIds = posts.map(post => post.id)
    const filter: KeenFilter[] = [
      {
        property_name: 'id',
        operator: 'in',
        property_value: postIds,
      },
    ]
    await this.$keenApi
      .analysis('count', 'Post Loaded', 'this_10_years', 'id', 'id', filter)
      .then((resp: any) => {
        resp.map((obj: any) => (this.clubPostViews += obj.result))
      })
  }

  async getClub() {
    const { data } = await this.$api.getMemberClub(this.clubId)
    await this.getClubViews()
    if (data.posts?.length > 0) {
      console.log(data.posts.map((post: any) => post.id.toString()))
      this.getClubPostViews(data.posts)
    }
    this.club = data
    this.loading = false
  }

  get isMobile() {
    return this.$isMobile()
  }

  async mounted() {
    await this.getClub()
    this.setLock()
    await this.trackView()
  }
}
